const shortcutsEn = {
  actions: {
    langSwitch: 'Toggle Japanese / English',
    shortcutsHelp: 'Show keyboard shortcuts'
  },
  list: {
    developerTools: 'Developer tools',
    scopeGlobal: 'Global',
    scopeLauncher: 'Launcher',
    scopeSession: 'Session',
    title: 'Keyboard shortcuts'
  }
};
export default shortcutsEn;